import Text from '@/shared-components/text/components/Text';

import './styles/CategoryItem.css';

export default function CategoryItem({ displayText, isSelected, onClickItem }) {
  return (
    <>
      <div className="search-filters-category-item__container" onClick={onClickItem}>
        <div className={`search-filters-category-item__select-display ${isSelected ? "active" : ""}`}/>
                
        <Text className="search-filters-category-item__display-text dots-on-overflow" small>
          {displayText}
        </Text>
      </div>
    </>
  );
}
